import { render, staticRenderFns } from "./PackSelection.vue?vue&type=template&id=28df8a88&"
import script from "./PackSelection.vue?vue&type=script&lang=ts&"
export * from "./PackSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports